<coin-v2-dual-pill
  themeColor="orange"
  icon="update"
  [textRight]="'general.update-available' | translate"
  [matTooltip]="'general.update-info' | translate"></coin-v2-dual-pill>
